import type { IOrderPayment } from '@rogue/universal'
import type { CreditCard } from '@/js/services/RogueTypes'

export function cardToPayment(card?:CreditCard):IOrderPayment {
  return {
    paymentType      : 'spreedly',
    _id              : card?._id,
    cardExpMonth     : card?.expMonth || 0,
    cardExpYear      : card?.expYear || 0,
    cardNumber       : card?.lastFour || '',
    cardType         : card?.ccType || '',
    transactionToken : card?.baseToken || '',
    amount           : 0,
  }
}
export function paymentToCard(payment:IOrderPayment): Partial<CreditCard> | null {
  if (payment.paymentType !== 'spreedly' || !payment.transactionToken) {
    return null
  }

  const { cardType, cardNumber, transactionToken, cardExpYear, cardExpMonth } = payment

  return {
    expYear   : cardExpYear,
    expMonth  : cardExpMonth,
    baseToken : transactionToken,
    ccType    : cardType,
    lastFour  : cardNumber,
  }
}
